import GameIds from 'root/activities/hub/data/GameIds';
import Env from 'lib/Env';

export const { PLACEMENT_TOOL, TRO_BENCHMARK } = GameIds;
export const PLACEMENT_TOOL_ES = 'placement_tool_es';

export const RESULTS_API_URL = `${Env.API_URL}/support-data/v3/upload/ipt_scores`;

export const TRO_RESULTS_URL = `${Env.API_URL}/mclass-proxy-api/v3/tro/student`;

export const MCLASS_REDIRECT_URL = `${Env.MCLASS_HOME}/student-assessment/`;

export const SAVED_DATA_VERSION = '1.0';

export const PREVENT_SKILL_SCAN_PARAM = 'preventSkillScan';

export const INVALID_TRO_RESULT_PARAM = 'hasTroError';

export const BENCHMARK_MODE_PARAM = 'benchmarkMode';

// TODO: can remove this and all references after admin panel gets updated post-login migration
export const LOCAL_STORAGE_KEYS = {
  LOCAL_APT_TYPE: 'localAptType',
  REDIRECT_TO_IPT: 'redirectToIPT',
  REDIRECT_TO_IPT_LECTURA: 'redirectToIPT_lectura',
  IPT_TYPE: 'iptType',
  IPT_TYPE_LECTURA: 'iptType_lectura',
  IS_FIRST_LOGIN: 'isFirstLogin',
};

export const ACTIONS = {
  SET_ROUND_SESSION_ID: 'SET_ROUND_SESSION_ID',
  SET_MEASURES_FOR_GRADE: 'SET_MEASURES_FOR_GRADE',
  BEGIN_NEXT_MEASURE: 'BEGIN_NEXT_MEASURE',
  COMPLETE_CURRENT_MEASURE: 'COMPLETE_CURRENT_MEASURE',
  LOAD_INTERSTITIAL: 'LOAD_INTERSTITIAL',
  SUBMIT_MEASURE_SCORE: 'SUBMIT_MEASURE_SCORE',
  COMPLETE_EVENTS_FIRED: 'COMPLETE_EVENTS_FIRED',
  UPDATE_IPT_METRICS: 'UPDATE_IPT_METRICS',
  UPDATE_COMPLETE_IPT_METRICS: 'UPDATE_COMPLETE_IPT_METRICS',
  SET_TRO_REQUEST: 'SET_TRO_REQUEST',
  SET_IS_VALID_TRO_RESULT: 'SET_IS_VALID_TRO_RESULT',
  SET_BENCHMARK_MODE_REDIRECT_FLAG: 'SET_BENCHMARK_MODE_REDIRECT_FLAG',
  RESET_BENCHMARK_MODE_REDIRECT_FLAG: 'RESET_BENCHMARK_MODE_REDIRECT_FLAG',
  RESET_BENCHMARK_EOY: 'RESET_BENCHMARK_EOY',
  SET_RWR_COMPLETE: 'SET_RWR_COMPLETE',
  SET_SHOULD_DISPLAY_AMP_GLOBAL_NAV: 'SET_SHOULD_DISPLAY_AMP_GLOBAL_NAV',
  SET_TRO_ERROR: 'SET_TRO_ERROR',
};

export const SCREENS = {
  LOADING: 'LOADING',
  INTERSTITIAL: 'INTERSTITIAL',
  MEASURE: 'MEASURE',
};

export const INTERSTITIAL_IDS = {
  INTRO: 'INTRO',
  WELCOME_BACK: 'WELCOME_BACK',
  MIDDLE: [
    0,
    1,
    2,
    3,
    4,
  ],
  OUTRO: 'OUTRO',
  INVALID_TRO_RESULT: 'INVALID_TRO_RESULT',
  BUMPER_GEAR: 'BUMPER_GEAR',
  BUMPER_LIGHTS: 'BUMPER_LIGHTS',
  BUMPER_PAINT: 'BUMPER_PAINT',
};

export const AVATAR_STATES = {
  IDLE: 'IDLE',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  INSTRUCTING: 'INSTRUCTING',
  SPEAKING: 'SPEAKING',
  ENCOURAGING: 'ENCOURAGING',
};

export const THEME = {
  LIGHT_TEAL: '#e1f4f1',
  TEAL: '#2db5a0',
  WHITE: '#ffffff',
  BLACK: '#000000',
};

export const METRIC_TYPE = {
  COUNT: 'count',
  TIME: 'time(ms)',
};

export const APT_TYPES = {
  MOY: 'MOY',
  EOY: 'EOY',
  BOY: 'BOY',
};

export const APT_IDS = {
  BENCHMARK_ID: 'benchmarkId',
  RWR_ID: 'rwrId',
  MTG_ID_STORY_1: 'mtgIdStory1',
  MTG_ID_STORY_2: 'mtgIdStory2',
  LETTER_SOUND_CORRESPONDENCES: 'letterSoundCorrespondences',
  SYLLABLE_DECODING: 'syllableDecodingId',
  BLENDING_ID: 'blending',
  SEGMENTING_ID: 'segmenting',
};

export const ASSESSMENT_TYPES = {
  PLACEMENT_APT: 'isPlacementAPT',
  BENCHMARK_APT: 'isBenchmarkAPT',
  PLACEMENT_ARBA: 'isPlacementARBA',
  BENCHMARK_ARBA: 'isBenchmarkARBA',
  BENCHMARK_MODE: 'isBenchmarkModeOn',
};

export const ASSESSMENT_PATHS = {
  APT: 'APT', // RWR + MTG
  ARBA: 'TRO-APT', // RWR + TRO
};
